import React, { useState } from 'react';
import { useGetBookingStatistics } from '../../hooks/react-query/useAdmin';
import { TableSkeletion } from '../elements/skeletions';
import { ExportList } from '../elements/exportList';
import {
  exportOptions,
  exportStatisticsToCSV,
  exportStatisticsToXLS,
  exportToPdf,
} from '../../utils/exports';
import Container from '../elements/container';

const BookingStatics = () => {
  const { data, isLoading } = useGetBookingStatistics();
  const [popoverExport, setPopoverExport] = useState(false);

  if (isLoading) {
    return (
      <Container>
        <TableSkeletion />
      </Container>
    );
  }

  const dataManipulate = () => {
    return data.data.map((el) => {
      return [el.label, `${el.value}`];
    });
  };

  const generatePdfDocument = (documentData) => {
    const headers = [
      { text: 'label', style: 'tableHeader', alignment: 'center' },
      { text: 'value', style: 'tableHeader', alignment: 'center' },
    ];

    const body = [];
    documentData.forEach((itm) => {
      const row = [];
      headers.forEach((head) => {
        row.push({ text: itm[head.text] });
      });
      body.push(row);
    });

    const table = [headers, ...body];
    const width = headers.map((el) => {
      const length = headers.length;
      // return "auto";
      return `${100 / length}%`;
    });

    const styles = {
      table: {
        fontSize: 12,
        alignment: 'center',
      },
    };

    exportToPdf({
      table,
      styles,
      fileName: 'Booking Statistics',
      width,
    });
  };

  const handleExport = (type) => {
    const rows = dataManipulate();
    if (type === 'pdf') {
      generatePdfDocument(data.data);
    } else if (type === 'csv') {
      exportStatisticsToCSV(rows, 'booking_statistics');
    } else if (type === 'xls') {
      exportStatisticsToXLS(rows, 'booking_statistics');
    }
  };

  return (
    <>
      <div className="flex flex-col gap-6 max-lg:h-[calc(100vh-140px)] lg:max-h-[60vh] overflow-auto scrollbar w-full">
        {data.data.map(({ label, name, value }) => {
          return (
            <div
              key={name}
              className="flex gap-6 py-3 px-6 justify-between bg-powdergrey rounded-xl"
            >
              <span className="text-body"> {label}</span> <h6>{value}</h6>
            </div>
          );
        })}
      </div>
      <div className="flex items-center justify-center flex-col gap-2 max-lg:w-full">
        <ExportList
          isOpen={popoverExport}
          exportOptions={exportOptions}
          setPopoverExport={setPopoverExport}
          handleExport={handleExport}
          className="max-lg:flex"
        />
      </div>
    </>
  );
};

export default BookingStatics;
